
export const Menuitems=[
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-house-user"
    },
    {
        title : "About",
        url : "/About",
        cName : "nav-links",
        icon : "fa-solid fa-circle-info"
    },
    {
        title : "Service",
        url : "/Service",
        cName : "nav-links",
        icon : "fa-solid fa-briefcase"
    },
    {
        title : "Contact",
        url : "#footer",
        cName : "nav-links",
        icon:"fa-solid fa-address-book"
    },
    {
        title : "Login",
        url : "/signup",
        cName : "nav-links",
        icon:"fa-solid fa-address-book"
    },

]